module.exports = __webpack_public_path__ + "img/w3_chevron_down_dark.cdc86b2e.cdc86b2e.png";